import Vue from 'vue';
import { Component } from 'vue-property-decorator';
// components
import TreeList from '@gnb/components/Common/TreeList.vue';
import api from '@gnb/api/common'
import FolderList from './FolderList.vue';
@Component({
    components: { TreeList, FolderList },
})
export default class SimpleFolderList extends Vue {
    //
    // ──────────────────────────────────────────────── I ──────────
    //   :::::: D A T A : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────
    //

    selectedFolder: gnb.MailboxFolder | null = null;
    folders: gnb.FolderItem[] = [];
    //
    // ──────────────────────────────────────────────────────── I ──────────
    //   :::::: C O M P U T E D : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────────────
    //

    get filteredFolders() {
        const getFolderName = (folders: gnb.FolderItem[], depth: number = 0) => {
            folders.forEach((f) => {

                if (depth == 0) {
                    (f as gnb.FolderItem).expanded = false;
                }

                f.selected = this.selectedFolder?.id === f.id;
                if (f.children != null) {
                    getFolderName(f.children as gnb.FolderItem[], ++depth);
                }
            });
        }
        var exceptFolderNames = ['동기화 문제', '정크 메일']

        getFolderName(this.folders);

        this.folders.map((item:gnb.FolderItem) => {
            switch(item.wellKnownFolderName){
                case 'inbox':
                    item.displayName = this.$t('받은_편지함').toString();
                    break;
                case 'sentitems':
                    item.displayName = this.$t('W_Mail_FolderSentbox').toString();
                    break;
                case 'outbox':
                    item.displayName = this.$t('보낼_편지함').toString();
                    break;
                case 'drafts':
                    item.displayName = this.$t('W_Mail_FolderDrafts').toString();
                    break;
                case 'deleteditems':
                    item.displayName = this.$t('W_Mail_FolderDeletedItems').toString();
                    break;
            }
        });

        //return this.folders.filter((f: gnb.FolderItem) => !f.wellKnownFolderName && !f.userWellKnownName);
        return this.folders.filter((f: gnb.FolderItem) => !exceptFolderNames.includes(f.displayName));
    }
    

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: M E T H O D S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //
    select(folder: gnb.MailboxFolder) {
        this.selectedFolder = folder;
        this.$emit('select', folder);
    }

    //
    // ────────────────────────────────────────────────────────── I ──────────
    //   :::::: L I F E C Y C L E : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────────
    //

    created(){
        api.getFolder().then((res)=>{
            this.folders = res;
        });
    }

}
